import { render, staticRenderFns } from "./TotalizadorContas.vue?vue&type=template&id=5399b14e&scoped=true"
import script from "./TotalizadorContas.vue?vue&type=script&lang=js"
export * from "./TotalizadorContas.vue?vue&type=script&lang=js"
import style0 from "./TotalizadorContas.vue?vue&type=style&index=0&id=5399b14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399b14e",
  null
  
)

export default component.exports